<div class="machines-card">
  <div class="machines-card-content" cdkDropList (cdkDropListDropped)="onDrop($event)">
    <div *ngFor="let machine of machines; let i = index" 
          cdkDrag
          class="machine-item">
      <div class="machine-item-content" tabindex="0"  (keydown.enter)="selectMachine(i, machine)">      
      <img cdkDragHandle 
              src="../../../assets/icon/reorder.svg" 
             class="drag-handle"
             alt="drag"                  
             tooltip="{{ 'Drag to reorder' | translate }}"
             placement="top">
      <div class="machine-label" 
            [attr.data-fulltext]=machine?.machine_Name 
            [ngClass]="{'active-label': activeMachineIndex === i}" 
            (click)="selectMachine(i, machine)" 
            [tooltip]="machine?.machine_Name" 
            placement="top">
            {{ machine?.machine_Name }}
        </div>
      </div>
    </div>
  </div>
</div>